import * as React from "react";
//#region types
import { TranslationKeys } from "translations";
import { LoginLayoutProps } from "models/propTypes/loginPropTypes";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Navigate } from "react-router";
import { Grid, Hidden } from "@mui/material";
//#endregion
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
import { CSSHelper, EnvHelper, LocalizationHelperInstance } from "utils/helpers";
import LogoWhite from "images/logo-white.svg";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import TestEnvironmentDropdown from "components/common/testEnvironmentDropdown";

const LoginLayout: React.FC<LoginLayoutProps> = (props) => {
  const loginThemes = [StyleEnums.DisplayType.Info, StyleEnums.DisplayType.Warning];

  const isAuthenticated = useSelector((store: AppState) => store.auth.isAuthorized);
  const showEULA = useSelector((store: AppState) => store.auth.loggedInUser.unsignedEula);

  const displayType = React.useMemo((): StyleEnums.DisplayType => {
    const randomNum = Math.floor(Math.random() * 10);
    return loginThemes[randomNum % loginThemes.length];
  }, []);

  return isAuthenticated ? (
    showEULA ? (
      <Navigate to="/EULA" replace />
    ) : (
      <Navigate to="/" replace />
    )
  ) : (
    <Grid
      container
      direction="column"
      className={clsx(cssExports.loginScreenInner, CSSHelper.getLoginThemeRootClass(displayType))}
    >
      {EnvHelper.getIsTestEnvironment() && <TestEnvironmentDropdown />}
      <Grid container item className={cssExports.loginScreenTitle}>
        <div className={cssExports.logoInvert}>
          <img src={LogoWhite} alt="Wint" />
        </div>
        <div>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.LoginTitle)}</div>
      </Grid>

      <Grid item container className={clsx(cssExports.loginColumns)}>
        <Grid item container md={6} className={clsx(cssExports.loginLeft)}>
          <Grid className={clsx(cssExports.loginScreenAbout)}>
            <Hidden smDown>
              <Grid container justifyContent="center">
                <Grid className={cssExports.aboutContainer}>
                  <Grid container justifyContent="center">
                    <label className={cssExports.aboutBubble}>
                      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.AboutBubbleText)}
                    </label>
                  </Grid>
                  <Grid container justifyContent="center" className={cssExports.aboutText}>
                    {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.AboutText)}
                  </Grid>
                </Grid>
              </Grid>
            </Hidden>
          </Grid>
        </Grid>

        <Grid item container md={6} justifyContent="flex-end" className={clsx(cssExports.loginRight)}>
          <Grid container className={cssExports.loginScreenLoginContainer}>
            {props.render(displayType, isAuthenticated)}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginLayout;
